export default __webpack_public_path__ + "static/media/Fraction_07.caa4af24.png";